export const DEFAULT_LOCALE = 'en';

export default () => {
  const [locale] = navigator.language.split('-');
  return locale || DEFAULT_LOCALE;
};
